/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandFlickr = createReactComponent("brand-flickr", "IconBrandFlickr", [
  ["path", { d: "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }]
]);

export { IconBrandFlickr as default };
//# sourceMappingURL=IconBrandFlickr.js.map
